import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Menu, MenuItem } from '@sm/wds-react';
import { Query } from 'react-apollo';
import getNavBarLinks from './getNavBarLinks';

import { DesktopScreen } from '../../../..';

import navBarQuery from './NavBar.graphql';

const NavBarAuthed = ({ user: { session } }) => {
  return (
    <DesktopScreen>
      <Query query={navBarQuery}>
        {({ loading, error, data }) => {
          if (loading) return <div className="sm-header--nav-auth" />;
          if (error) return <div className="sm-header--nav-auth" />;

          const navBarLinks = getNavBarLinks(data, session);

          const NavBarTeamsTrigger = name => {
            return (
              <Button
                size="sm"
                variant="text"
                className="sm-header__nav-cta--alt sm-header__text"
                key={name}
              >
                {name}
                <Icon>–</Icon>
              </Button>
            );
          };
          return (
            <div className="sm-header__nav--auth">
              {navBarLinks.map(link => {
                const { name, path } = link;
                const menuItems = link.menu_items;
                if (link.key === 'team') {
                  return (
                    <Menu
                      placement="bottom-left"
                      noRules
                      dense
                      menuTrigger={NavBarTeamsTrigger(name)}
                      key={name}
                    >
                      {menuItems.map(item => {
                        return (
                          <a key={`${item.name}-userMenu`} href={item.path}>
                            <MenuItem>{item.name}</MenuItem>
                          </a>
                        );
                      })}
                    </Menu>
                  );
                }
                if (!name) {
                  return null;
                }
                return (
                  <Button
                    variant="text"
                    size="sm"
                    className="sm-header__nav-cta--alt sm-header__text"
                    href={path}
                    key={name}
                  >
                    {name}
                  </Button>
                );
              })}
            </div>
          );
        }}
      </Query>
    </DesktopScreen>
  );
};

NavBarAuthed.propTypes = {
  user: PropTypes.shape({
    session: PropTypes.shape({
      isAdminImpersonation: PropTypes.bool
    })
  }).isRequired
};

export default NavBarAuthed;
